import { connect } from 'react-redux';

import { Creators as userActions } from 'Reducers/user';
import { Creators as transientActions } from 'Reducers/transient';
import { Creators as adminActions } from 'Reducers/adminOnboarding';
import { Creators as dailyFiguresActions } from 'Reducers/adminDailyFigures';

import DailyFigures from './view';

export default connect(
  state => ({
    transient: state.transient,
    user: state.user
  }),
  {
    getAdminDailyFigures: dailyFiguresActions.getAdminDailyFigures,
    getCampaignsByClientType: dailyFiguresActions.getCampaignsByClientType,
    getClientsByClientType: dailyFiguresActions.getClientsByClientType,
    getMarketingCompanies: adminActions.getMarketingCompanies,
    updateDailyFiguresProps: dailyFiguresActions.updateProps,
    updateTransientProps: transientActions.updateProps,
    updateUserProps: userActions.updateProps
  }
)(DailyFigures);
